// src/hooks/useTyped.js
import { useState, useEffect } from 'react';
const WORDS = ['scalable backend systems','AI document pipelines','LLM integrations','cloud-native APIs','workflow automation'];
export default function useTyped() {
  const [text, setText] = useState('');
  useEffect(() => {
    let wi=0, ci=0, del=false, timer;
    const step = () => {
      const w = WORDS[wi];
      if (!del) { setText(w.slice(0,++ci)); if(ci===w.length){del=true;timer=setTimeout(step,1400);return;} }
      else { setText(w.slice(0,--ci)); if(ci===0){del=false;wi=(wi+1)%WORDS.length;timer=setTimeout(step,300);return;} }
      timer = setTimeout(step, del ? 35 : 65+Math.random()*30);
    };
    step(); return () => clearTimeout(timer);
  }, []);
  return text;
}
